module.exports = __webpack_public_path__ + "static/img/areainfo3.9fd10b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/areainfo3.png
// module id = BYjo
// module chunks = 0